/**
 * Medal icon (boxicons-style) with subscription years on the disk.
 * Number is SVG <text> so it stays centered regardless of layout/CSS order.
 */
export function SubscriberYearsMedal({ years, size = "md" }) {
  if (!years || years < 1) return null;

  const px = size === "sm" ? 14 : 21;
  const label = `${years} ${years === 1 ? "anno" : "anni"} di abbonamento`;
  const fontSize = years >= 10 ? (size === "sm" ? 5.5 : 7) : size === "sm" ? 7 : 8.5;

  return (
    <span
      className="subscriber-years-medal"
      aria-label={label}
      title={label}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={px}
        height={px}
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="subscriber-years-medal__svg"
      >
        <path
          fill="currentColor"
          d="M12 18c4.41 0 8-3.59 8-8s-3.59-8-8-8s-8 3.59-8 8s3.59 8 8 8"
        />
        <path
          fill="currentColor"
          d="M7 17.48V21c0 .35.18.67.47.85s.66.2.97.04l3.55-1.78l3.55 1.78a.997.997 0 0 0 1.45-.88v-3.52c-1.43.96-3.15 1.52-5 1.52s-3.57-.56-5-1.52z"
        />
        <text
          x="12"
          y="10"
          textAnchor="middle"
          dominantBaseline="central"
          fill="#fff"
          style={{
            fontSize,
            fontWeight: 700,
            paintOrder: "stroke fill",
            stroke: "rgba(0,0,0,0.25)",
            strokeWidth: 0.35,
          }}
        >
          {years}
        </text>
      </svg>
    </span>
  );
}
